// extracted by mini-css-extract-plugin
export default {"body":"App_body__00BrA","appbar":"App_appbar__GcIMT","logo":"App_logo__KFImf"};